module.exports = __webpack_public_path__ + "static/county-logo-2bfe21306a9b215c818f02a7461b4c27.jpeg";